import { useStats } from "@/lib/hooks/useApi";
import { usePrivy } from "@privy-io/react-auth";
import { useNavigate } from "@tanstack/react-router";
import { usePostHog } from "posthog-js/react";
import { useEffect, useMemo } from "react";

export const PosthogLoginIdentifier = () => {
  const navigate = useNavigate();
  const posthog = usePostHog();
  const { ready: privyReady, authenticated, user } = usePrivy();
  const { data: stats } = useStats(user?.wallet?.address ?? "");

  const username = useMemo(() => {
    if (!user) return "None";
    if (user.google) return user.google.email;
    if (user.twitter) return user.twitter.username;
    if (user.wallet) return user.wallet.address;
    return "None";
  }, [user]);

  useEffect(() => {
    if (privyReady && authenticated && user && !!user.wallet) {
      console.log("[Posthog] Identify user", {
        privyReady,
        authenticated,
        user,
      });
      if (!posthog._isIdentified()) {
        posthog.identify(user.wallet.address, {
          name: stats?.username,
        });
      }
      return;
    }
  }, [
    privyReady,
    authenticated,
    navigate,
    user,
    username,
    posthog,
    stats?.username,
  ]);

  return null;
};
